export default [
  // {
  //   path: '/school-contacts',
  //   title: 'schoolContact',
  //   icon: 'fas fa-phone-volume',
  //   permission: 'view-school-contacts'
  // },
  {
    path: '/calendars',
    title: 'calendar',
    icon: 'fas fa-calendar',
    permission: 'view-calendars'
  },
  {
    path: '/holidays',
    title: 'holiday',
    icon: 'fas fa-plane',
    permission: 'view-holidays'
  },
  // {
  //   path: '/events',
  //   title: 'eventActivity',
  //   icon: 'fas fa-chart-line',
  //   permission: 'view-events'
  // },

  {
    path: '/exam-schedules',
    title: 'examSchedule',
    icon: 'fas fa-clipboard-list',
    permission: 'view-exam-schedules'
  },
  {
    path: '/class-attendances',
    title: 'classAttendance',
    icon: 'far fa-user',
    permission: 'view-class-attendances'
  },
  // {
  //   path: '/homeworks',
  //   title: 'homework',
  //   icon: 'fas fa-book',
  //   permission: 'view-homeworks'
  // },
  // {
  //   path: '/campus-attendance-teachers',
  //   title: 'campusAttendance',
  //   icon: 'far fa-user',
  //   permission: 'view-campus-attendances'
  // },
  // {
  //   path: '/student-galleries',
  //   title: 'studentGallery',
  //   icon: 'fas fa-images',
  //   permission: 'view-student-galleries'
  // },
  // {
  //   icon: 'fas fa-align-center',
  //   path: '/student-scoring-component-entries',
  //   title: 'scoreComponentEntry',
  //   permission: 'view-student-scoring-component-entries'
  // },
  {
    icon: 'fas fa-user-graduate',
    path: '/student-scoring-entries',
    title: 'scoreEntry',
    permission: 'view-student-scoring-entries'
  },
  {
    path: '/notification-histories',
    title: 'notificationHistory',
    icon: 'fas fa-history',
    permission: 'view-notification-histories'
  },
  {
    icon: 'fa fa-comment',
    path: '/chats',
    title: 'chat',
    permission: 'view-chats'
  },
  // {
  //   path: '/portfolio-photos',
  //   title: 'portfolioPhoto',
  //   icon: 'fas fa-images',
  //   permission: 'view-portfolio-photos'
  // },
  // {
  //   path: '/portfolio-preview-lists',
  //   title: 'portfolioReview',
  //   icon: 'fas fa-images',
  //   permission: 'view-portfolio-review-photos'
  // },
  // {
  //   path: '/disciplinary-actions',
  //   title: 'disciplinaryAction',
  //   icon: 'fas fa-book',
  //   permission: 'view-disciplinary-actions'
  // },
  // {
  //   title: 'report',
  //   icon: 'fas fa-file',
  //   children: [
  //     {
  //       path: '/report/report-cards',
  //       title: 'reportCards',
  //       permission: 'view-report-cards'
  //     },
  //     {
  //       path: '/report/report-scorings',
  //       title: 'reportScoring',
  //       permission: 'view-report-scorings'
  //     },
  //     {
  //       path: '/report/student-enrollments',
  //       title: 'studentEnrollment',
  //       permission: 'view-student-enrollment'
  //     },
  //     // {
  //     //   path: '/report/final-results',
  //     //   title: 'finalResult',
  //     //   permission: 'view-final-results'
  //     // },
  //     // {
  //     //   path: '/report/score-lists',
  //     //   title: 'scoreList',
  //     //   permission: 'view-score-lists'
  //     // },
  //     {
  //       path: '/report/student-score-sheets',
  //       title: 'studentScoreSheet',
  //       permission: 'view-report-student-score-sheets'
  //     }
  //   ]
  // }
]
